import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, ShieldAlert, Clock, X, Rocket } from "lucide-react";
import { Button } from "../components/ui/button";

const VideoPlayer = () => {
  const { token } = useParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/video/validate/${token}`
        );
        if (response.ok) {
          setStatus("valid");
        } else {
          setStatus("expired");
        }
      } catch {
        setStatus("error");
      }
    };

    if (token) {
      validateToken();
    }
  }, [token]);

  // Disable right-click on video
  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="max-w-5xl w-full">
        {/* Header */}
        <div className="text-center mb-6">
          <img
            src="https://customer-assets.emergentagent.com/job_altas-demo/artifacts/tufzwqkc_bluteca_logo_no_bg.png"
            alt="Bluteca Logo"
            className="h-10 mx-auto brightness-0 invert mb-4"
          />
        </div>

        {status === "loading" && (
          <div className="flex flex-col items-center justify-center h-64">
            <Loader2 className="w-10 h-10 text-blue-400 animate-spin mb-4" />
            <p className="text-slate-400">Verificando acceso...</p>
          </div>
        )}

        {status === "valid" && (
          <>
          <div className="bg-black rounded-xl overflow-hidden shadow-2xl">
            <video
              controls
              controlsList="nodownload"
              disablePictureInPicture
              onContextMenu={handleContextMenu}
              className="w-full"
              style={{ maxHeight: "75vh" }}
              data-testid="video-player"
            >
              <source
                src={`${process.env.REACT_APP_BACKEND_URL}/api/video/stream/${token}`}
                type="video/mp4"
              />
              Tu navegador no soporta la reproducción de video.
            </video>
            <div className="bg-slate-800 px-6 py-3 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <p className="text-slate-400 text-sm">Video Demo - Bluteca</p>
                <div className="flex items-center gap-2 text-slate-500 text-xs">
                  <Clock className="w-3 h-3" />
                  <span>Expira en 24h</span>
                </div>
              </div>
              <div className="flex gap-2">
                <Button
                  onClick={() => window.close()}
                  variant="outline"
                  size="sm"
                  className="border-slate-600 text-slate-300 hover:bg-slate-700"
                  data-testid="video-close-btn"
                >
                  <X className="w-4 h-4 mr-1" />
                  Cerrar
                </Button>
                <Button
                  onClick={() => window.location.href = "https://app.bluteca.com"}
                  size="sm"
                  className="bg-orange-500 hover:bg-orange-600 text-white"
                  data-testid="video-start-btn"
                >
                  <Rocket className="w-4 h-4 mr-1" />
                  Iniciar
                </Button>
              </div>
            </div>
          </div>
          </>
        )}

        {status === "expired" && (
          <div className="bg-slate-800 rounded-xl p-12 text-center">
            <ShieldAlert className="w-16 h-16 text-amber-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">
              Enlace no válido o expirado
            </h2>
            <p className="text-slate-400">
              Este enlace de video ha expirado o no es válido. 
              Contacta con el equipo de Bluteca si necesitas acceso.
            </p>
          </div>
        )}

        {status === "error" && (
          <div className="bg-slate-800 rounded-xl p-12 text-center">
            <ShieldAlert className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">
              Error de conexión
            </h2>
            <p className="text-slate-400">
              No se pudo verificar el acceso. Inténtalo de nuevo más tarde.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
